<script setup>
import {ref} from 'vue'
import StaticTooltip from "@/components/common/other/StaticTooltip";
import Container from "@/components/common/other/Container";
import Button from "@/components/common/input/Button";
import AddressAndContact from "@/components/common/other/AddressAndContact"

import {inject} from 'vue'
import {useStore} from "vuex";

const shipments = inject("shipments");

const store = useStore();

function openTracking(url) {

  window.open(url);
}

</script>

<template class="cmp-detailed-information">
  <div id="Vue-3-component-detailed-information" class="cmp-detailed-information_wrapper">
    <div class="cmp-detailed-information_container">
      <AddressAndContact v-model="shipments.viewShipment"></AddressAndContact>
    </div>
    <div id="terms-detail" class="cmp-detailed-information_mode-banner-wrapper">
      <div class="cmp-detailed-information_mode-section-terms-banner">
        <div class="cmp-detailed-information_banner-icon-area">
          <i class="fa-duotone fa-file-invoice" style="color: #6e1844; font-size: 36px;"></i>
        </div>
        <div class="cmp-detailed-information_banner-info-area cmp-detailed-information_inco-terms">
          <div class="label cmp-detailed-information_heading-text">Incoterms:</div>
          <div style="width: max-content;">{{ shipments.viewShipment.detailedInformation.incoTerms.split('-')[0] }}
          </div>
          <StaticTooltip width="340" v-if="shipments.viewShipment.detailedInformation.incoTerms.split('-')[1]">
            <template #content>
              {{ shipments.viewShipment.detailedInformation.incoTerms.split('-')[1] }}
            </template>
            <div class="cmp-detailed-information_inco-terms-description">
              <i class="fa-solid fa-circle-info icon-info"></i>
              <span style="margin-left: 5px;">Hover for full description of this incoterm</span>
            </div>
          </StaticTooltip>
<!--          <span v-else style="margin-left: 5px;" class="global-no-data-placeholder">No incoterms description provided</span>-->
        </div>
      </div>
      <div v-if="shipments.viewShipment.mode.toLowerCase() === shipments.modes.courier.toLowerCase()"
           id="courier-detail">
        <div class="cmp-detailed-information_mode-section-terms-banner">
          <div class="cmp-detailed-information_banner-icon-area">
            <i class="fa-duotone fa-map-location-dot"></i>
          </div>
          <div class="cmp-detailed-information_banner-info-area">
            <div class="cmp-detailed-information_courier-detail-grid">
              <div class="consignment-number">
                <div class="label">Consignment Number</div>
                <div style="padding-top: 4px;">
                  {{ shipments.viewShipment.detailedInformation.courier.consignmentNumber }}
                </div>
              </div>
              <div class="pod-name">
                <div class="label">POD Name</div>
                <div style="padding-top: 4px;">{{ shipments.viewShipment.detailedInformation.courier.podName }}</div>
              </div>
              <div class="pod-date">
                <div class="label">POD Date</div>
                <div style="padding-top: 4px;">{{ shipments.viewShipment.detailedInformation.courier.podDate }}</div>
              </div>
              <div class="pod-date">
                <div class="label">POD Time</div>
                <div style="padding-top: 4px;">{{ shipments.viewShipment.detailedInformation.courier.podTime }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="shipments.viewShipment.mode.toLowerCase() === shipments.modes.sea.toLowerCase()" id="sea-detail">
        <div class="cmp-detailed-information_mode-section-terms-banner">
          <div class="cmp-detailed-information_banner-icon-area">
            <i class="fa-duotone fa-ship" style="color: #006cd4"></i>
          </div>
          <div class="cmp-detailed-information_banner-info-area">
            <div class="cmp-detailed-information_sea-detail-grid">
              <div class="consignment-number">
                <div class="label">B/L Number</div>
                <div style="padding-top: 4px;">{{ shipments.viewShipment.detailedInformation.sea.blNumber }}</div>
              </div>
              <div class="pod-name">
                <div class="label">HBL</div>
                <div style="padding-top: 4px;">{{ shipments.viewShipment.detailedInformation.sea.hbl }}</div>
              </div>
              <div class="pod-date">
                <div class="label">Vessel</div>
                <div style="padding-top: 4px;">{{ shipments.viewShipment.detailedInformation.sea.vessel }}</div>
              </div>
              <div class="pod-date">
                <div class="label">Voyage Number</div>
                <div style="padding-top: 4px;">{{ shipments.viewShipment.detailedInformation.sea.voyageNumber }}</div>
              </div>
              <div class="awb-tracking" style="padding-top: 3px;">
                <Button
                    v-if="store.state.userSettings.showSeaTrackingLink"
                    :disabled="!shipments.viewShipment.detailedInformation.sea.trackingUrl"
                    @click="openTracking(shipments.viewShipment.detailedInformation.sea.trackingUrl)"
                    text="TRACK"
                    type="secondary">
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="shipments.viewShipment.mode.toLowerCase() === shipments.modes.air.toLowerCase()" id="flight-detail">
        <div class="cmp-detailed-information_mode-section-terms-banner">
          <div class="cmp-detailed-information_banner-icon-area">
            <i class="fa-duotone fa-plane-engines" style="color: #020e32;"></i>
          </div>
          <div class="cmp-detailed-information_banner-info-area">
            <div class="cmp-detailed-information_flight-detail-grid">
              <div class="flight-number">
                <div class="label">Flight Number</div>
                <div style="padding-top: 4px;">{{ shipments.viewShipment.detailedInformation.air.flightNumber }}</div>
              </div>
              <div class="flight-2">
                <div class="label">Flight 2 No.</div>
                <div style="padding-top: 4px;">{{ shipments.viewShipment.detailedInformation.air.secondFlightNumber }}
                </div>
              </div>
              <div class="awb-number">
                <div class="label">AWB Number</div>
                <div style="padding-top: 4px;">{{ shipments.viewShipment.detailedInformation.air.awbNumber }}</div>
              </div>
              <div class="hawb">
                <div class="label">HAWB</div>
                <div style="padding-top: 4px;">{{ shipments.viewShipment.detailedInformation.air.hawb }}</div>
              </div>
              <div class="flight-date">
                <div class="label">Flight Date</div>
                <div style="padding-top: 4px;">{{ shipments.viewShipment.detailedInformation.air.flightDate }}</div>
              </div>
              <div class="awb-tracking" style="padding-top: 3px;">
                <Button
                    v-if="store.state.userSettings.showAirTrackingLink"
                    :disabled="!shipments.viewShipment.detailedInformation.air.trackingUrl"
                    @click="openTracking(shipments.viewShipment.detailedInformation.air.trackingUrl)"
                    text="AWB Tracking"
                    type="secondary">
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="shipments.viewShipment.mode.toLowerCase() === shipments.modes.courier.toLowerCase()"
           id="courier-more-detail">
        <div class="cmp-detailed-information_mode-section-terms-banner">
          <div class="cmp-detailed-information_banner-icon-area">
            <i class="fa-duotone fa-file-invoice-dollar" style="color: #25868f "></i>
          </div>
          <div class="cmp-detailed-information_banner-info-area">
            <div class="cmp-detailed-information_courier-detail-grid">
              <div class="additional-ref">
                <div class="label">Additional Ref</div>
                <div style="padding-top: 4px;">{{ shipments.viewShipment.detailedInformation.courier.additionalRef }}
                </div>
              </div>
              <div class="value">
                <div class="label">Value</div>
                <div v-if="shipments.viewShipment.detailedInformation.courier.value" style="padding-top: 4px;">
                  {{ shipments.viewShipment.detailedInformation.courier.value }}
                </div>
                <div v-else style="padding-top: 4px;">No Data</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>

.cmp-detailed-information {

  &_wrapper {
    display: flex;
    font-size: 12px;
  }

  &_wrapper &_container {
    width: 100%;
  }

  &_wrapper &_container:nth-child(1) {
    border-right: 1px solid #cfcfcf;
    height: 280px;
  }

  &_heading-area {
    display: flex;
    align-items: center;
    padding: 10px 10px 0 10px;
  }

  &_heading-text {
    margin-left: 20px;
  }

  &_mode-banner-wrapper {
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-top: 20px;
  }

  &_mode-section-terms-banner {
    display: flex;
    border: 1px solid #e7e7e7;
    border-radius: var(--rounded-corners);
    align-items: center;
    height: 70px;
    background: #ffffff;
    width: 870px;
    margin-left: 33px;
  }

  &_banner-icon-area {
    font-size: 32px;
    margin-left: 10px;
    width: 40px;
    opacity: 0.6;
  }

  &_banner-icon-area i {
    margin-left: 13px;
  }

  &_banner-info-area {
    display: flex;
    margin-left: 28px;
    height: 40px;
    background-color: #eceff1;
    width: 88%;
    border-radius: 4px;
    gap: 10px;
  }

  &_inco-terms {
    align-items: center;
  }

  &_inco-terms-description {
    background-color: white;
    padding: 4px 10px 4px 10px;
    border-radius: 8px;
    margin-left: 30px;
  }

  &_courier-detail-grid {
    margin: 5px 0 0 20px;
    display: grid;
    grid-template-columns: 220px 270px 150px 100px;
  }

  &_flight-detail-grid {
    margin: 5px 0 0 20px;
    display: grid;
    grid-template-columns: 140px 120px 150px 130px 95px 100px;
  }

  &_sea-detail-grid {
    margin: 5px 0 0 20px;
    display: grid;
    grid-template-columns: 180px 140px 140px 200px 86px;
  }

}

</style>
